export default __webpack_public_path__ + "static/media/minus.ad75f238.svg";